import { render, staticRenderFns } from "./RefreshResults.vue?vue&type=template&id=e36284b6&scoped=true&"
import script from "./RefreshResults.vue?vue&type=script&lang=js&"
export * from "./RefreshResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36284b6",
  null
  
)

export default component.exports